// extracted by mini-css-extract-plugin
module.exports = {"button":"_6f25b66c20--button--1E1fQ","icon":"_6f25b66c20--icon--2xNVq"};